import { render } from "./BaseButton.vue?vue&type=template&id=6deec95e"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=6deec95e&lang=scss"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__